"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Dialog = __importStar(require("@radix-ui/react-dialog"));
const classnames_1 = __importDefault(require("classnames"));
const react_1 = require("react");
const Modal = ({ isOpen, centered, className, id, title, footer, toggle, children, }) => {
    const [open, setOpen] = (0, react_1.useState)(isOpen);
    (0, react_1.useEffect)(() => {
        setOpen(isOpen);
    }, [isOpen]);
    const handleOpenChange = (open) => {
        setOpen(open);
        toggle === null || toggle === void 0 ? void 0 : toggle();
    };
    return ((0, jsx_runtime_1.jsx)(Dialog.Root, { open: open, onOpenChange: handleOpenChange, children: (0, jsx_runtime_1.jsxs)(Dialog.Portal, { children: [(0, jsx_runtime_1.jsx)(Dialog.Overlay, { className: "modal-overlay" }), (0, jsx_runtime_1.jsxs)(Dialog.Content, { id: id, className: (0, classnames_1.default)('modal-content', className, { centered }), children: [title && ((0, jsx_runtime_1.jsx)(Dialog.Title, { className: "modal-header", asChild: true, children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h5", { className: "modal-title", children: title }), (0, jsx_runtime_1.jsx)(Dialog.Close, { asChild: true, children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn-close", "aria-label": "St\u00E4ng" }) })] }) })), (0, jsx_runtime_1.jsx)("div", { className: "modal-body", children: children }), footer && (0, jsx_runtime_1.jsx)("div", { className: "modal-footer", children: footer })] })] }) }));
};
exports.Modal = Modal;
